<div bsModal #slideRight="bs-modal" class="modal fade slide-right" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content-wrapper">
            <div class="modal-content">
                <div class="container-xs-height full-height">
                    <div class="row-xs-height">
                        <div class="modal-body col-xs-height col-middle">
                            <app-span-html [code]="policyText" ></app-span-html>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>